/**
 * money-format-fix.js — Tout Pour Le Barbecue
 *
 * Corrige l'affichage des prix calculés en JavaScript.
 *
 * LE PROBLÈME
 * Le format monétaire de la boutique est « {{amount_with_space_separator}} € »
 * (4 895,00 €). Le formatMoney livré par Kalles 4.1.5 ne connaît que cinq
 * placeholders, et celui-là n'en fait pas partie : son switch ne trouve aucun cas,
 * la valeur reste vide, et la fonction retourne « € » sans le montant.
 *
 * Le rendu Liquid, lui, est correct partout — Shopify sait formater ce placeholder.
 * Le défaut n'est donc visible que là où le JS réécrit un prix : produits à
 * variantes (_updatePrice), estimateur de frais de port, totaux recalculés.
 *
 * CE QUE FAIT CE FICHIER
 * 1. Il enveloppe formatMoney pour traiter les placeholders manquants, et délègue
 *    à la fonction d'origine pour tous les autres.
 * 2. Il répare les prix déjà effacés si le thème a eu le temps d'écrire avant nous.
 *
 * POURQUOI UN FICHIER À NOUS
 * theme.min.js est livré par Kalles : une mise à jour du thème écraserait toute
 * retouche faite dedans. Ce fichier-ci est à nous et survit aux mises à jour.
 * Même principe que compare-bar.js.
 *
 * Ne pas corriger le réglage Shopify à la place : passer à
 * amount_with_comma_separator afficherait « 6.690,00 € » sur les 24 variantes du
 * catalogue au-dessus de 1 000 €.
 */
(function () {
  'use strict';

  /* Placeholders Shopify absents du switch de Kalles.
     [précision, séparateur de milliers, séparateur décimal] */
  var MANQUANTS = {
    amount_with_space_separator: [2, ' ', ','],
    amount_with_period_and_space_separator: [2, ' ', '.'],
    amount_with_apostrophe_separator: [2, "'", '.']
  };

  var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  /* Même découpage que formatWithDelimiters du thème, pour un rendu identique. */
  function decouper(cents, precision, milliers, decimal) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var nombre = Number(cents);
    if (isNaN(nombre) || nombre === null) return '0';

    var parts = (nombre / 100).toFixed(precision).split('.');
    var entier = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + milliers);

    return entier + (parts[1] ? decimal + parts[1] : '');
  }

  function formatDeLaBoutique() {
    return window.T4Sconfigs && T4Sconfigs.moneyFormat;
  }

  function poser() {
    var devise = window.T4SThemeSP && T4SThemeSP.Currency;
    if (!devise || typeof devise.formatMoney !== 'function') return false;
    if (devise.formatMoney.__tplbFix) return true;

    var origine = devise.formatMoney;

    function formatMoney(cents, format) {
      var utilise = format || formatDeLaBoutique();
      var trouve = utilise && utilise.match(PLACEHOLDER);
      var regle = trouve && MANQUANTS[trouve[1]];

      if (!regle) return origine.apply(this, arguments);

      return utilise.replace(
        PLACEHOLDER,
        decouper(cents, regle[0], regle[1], regle[2])
      );
    }

    formatMoney.__tplbFix = true;
    devise.formatMoney = formatMoney;
    return true;
  }

  /* --- Réparation des prix déjà écrits ---------------------------------------
     Si le thème a rendu un prix avant que le correctif soit posé, l'élément
     contient « € » sans chiffre. On le réécrit à partir des données de variante
     présentes dans la page, en respectant l'ordre del/ins choisi dans le thème. */

  function contientUnChiffre(element) {
    return /\d/.test(element.textContent || '');
  }

  function variantesDeLaPage() {
    var noeud = document.querySelector('.pr_variants_json');
    if (!noeud) return null;
    try {
      return JSON.parse(noeud.textContent);
    } catch (e) {
      return null;
    }
  }

  function varianteCourante(variantes) {
    var demandee = new URLSearchParams(window.location.search).get('variant');
    var trouvee = null;

    if (demandee) {
      trouvee = variantes.filter(function (v) {
        return String(v.id) === String(demandee);
      })[0];
    }

    return trouvee || variantes[0] || null;
  }

  function reparer() {
    var cibles = [].slice
      .call(document.querySelectorAll('[data-product-price]'))
      .filter(function (element) {
        return !contientUnChiffre(element);
      });

    if (!cibles.length) return;

    var variantes = variantesDeLaPage();
    if (!variantes || !variantes.length) return;

    var variante = varianteCourante(variantes);
    if (!variante) return;

    var devise = window.T4SThemeSP && T4SThemeSP.Currency;
    if (!devise) return;

    var prix = devise.formatMoney(variante.price);
    var barre = variante.compare_at_price;
    var solde = barre && Number(barre) > Number(variante.price);

    cibles.forEach(function (element) {
      if (!solde) {
        element.textContent = prix;
        return;
      }

      var compare = devise.formatMoney(barre);
      var insDabord = element.getAttribute('data-formart-price') === 'ins-del';

      element.innerHTML = insDabord
        ? '<ins>' + prix + '</ins> <del>' + compare + '</del>'
        : '<del>' + compare + '</del> <ins>' + prix + '</ins>';
    });
  }

  /* --- Installation -----------------------------------------------------------
     Les scripts du thème sont injectés dynamiquement par le loader de
     render_bottom.liquid : on ne peut pas se contenter d'un ordre de balises.
     On tente donc de poser le correctif jusqu'à ce que la devise existe. */

  var DELAI = 20;
  var PLAFOND = 10000;
  var debut = Date.now();

  function installer() {
    if (poser()) {
      reparer();
      return;
    }
    if (Date.now() - debut < PLAFOND) {
      setTimeout(installer, DELAI);
    }
  }

  installer();

  /* Deuxième passe : le thème rend certains prix après le chargement complet. */
  window.addEventListener('load', function () {
    if (poser()) reparer();
  });
})();
